import { api } from '@cwd/lib/main';

export interface TemplateCopyAccountItem {
    AccountId: string;
    Name: string;
    PublicHost: string;
}

export interface IssueTemplateItem {
    IssueId: string;
    Subject: string;
    IssueName: string | null;
    LastModified: string;
    LastModifiedByName: string;
}

export interface SurveyTemplateItem {
    SurveyId: string;
    Title: string;
    SurveyName: string | null;
    LastModified: string;
    LastModifiedByName: string;
}

export interface SmsTemplateItem {
    SmsMessageId: string;
    Subject: string;
    Created: string;
    Modified: string;
    LastModifiedByName: string;
}

export const UNGAPPED_SYSTEM_USER_ID = '6E481FDF-E1E5-452A-B66D-D2DEBDBBCD50';

export interface CopyTemplatesRequest {
    AccountId: string;
    ClientCompanyId: string;
    ServiceSubscriptionId: string;
    IssueTemplateIds: string[];
    SurveyTemplateIds: string[];
    SmsTemplateIds: string[];
    TargetAccountIds: string[];
    SendConfirmationEmail: boolean;
    LastEditedByUserId: string | null;
}

export async function getTemplateCopyAccounts(clientCompanyId: string): Promise<TemplateCopyAccountItem[]> {
    return await api.get(`/BackOffice/TemplateCopy/Accounts/${clientCompanyId}`);
}

export async function getIssueTemplates(accountId: string): Promise<IssueTemplateItem[]> {
    return await api.get(`/BackOffice/TemplateCopy/IssueTemplates/${accountId}`);
}

export async function getSurveyTemplates(accountId: string): Promise<SurveyTemplateItem[]> {
    return await api.get(`/BackOffice/TemplateCopy/SurveyTemplates/${accountId}`);
}

export async function getSmsTemplates(accountId: string): Promise<SmsTemplateItem[]> {
    return await api.get(`/BackOffice/TemplateCopy/SmsTemplates/${accountId}`);
}

export async function copyTemplates(request: CopyTemplatesRequest): Promise<void> {
    await api.post('/BackOffice/TemplateCopy', request);
}
